// extracted by mini-css-extract-plugin
module.exports = {"casesList":"CasesList_casesList__2uzk8","search":"CasesList_search__2L5nM","selects":"CasesList_selects__-13iA","list":"CasesList_list__2hcFH"};